const drawShadow = (ctx: CanvasRenderingContext2D, isHovered: boolean) => {
      // Draw shadow under the image
      ctx.shadowColor = !isHovered ? "transparent" : "#fdbb2c";
      ctx.shadowBlur = 10;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
};

export default drawShadow;